import { SettingStorage } from '@services/SettingStorage';

const STORAGE_KEY = 'custom-dashboard';

interface PageBreaksPreference {
  showPageBreaks: boolean;
}

const getStorageKey = (initiativeId: string): string => {
  return `${STORAGE_KEY}:${initiativeId}`;
};

export const loadPageBreaksPreference = (initiativeId: string): boolean => {
  const key = getStorageKey(initiativeId);
  const stored = SettingStorage.getItem(key);

  if (!stored) {
    return false;
  }

  try {
    const parsed: PageBreaksPreference = JSON.parse(stored);
    return parsed.showPageBreaks ?? false;
  } catch {
    return false;
  }
};

export const savePageBreaksPreference = (initiativeId: string, showPageBreaks: boolean): void => {
  const key = getStorageKey(initiativeId);
  const value: PageBreaksPreference = { showPageBreaks };
  SettingStorage.setItem(key, JSON.stringify(value));
};
